import { Link } from "react-router-dom";
import { Lockup } from "./Lockup";
import { useT, useLp } from "../lib/i18n";

interface Props {
  children: React.ReactNode;
  step?: { current: number; total: number; label: string };
}

export function AuthShell({ children, step }: Props) {
  const t = useT();
  const lp = useLp();

  return (
    <div className="min-h-screen flex flex-col">
      <header className="mx-auto w-full max-w-6xl px-6 py-6 flex items-center justify-between">
        <Link to={lp + "/"} aria-label={t.auth.shell.homeLabel} className="block">
          <Lockup className="h-7 w-auto" />
        </Link>
        {step && (
          <div className="font-mono text-xs uppercase tracking-wider text-ink/50 dark:text-paper/50">
            {t.auth.shell.step(step.current, step.total, step.label)}
          </div>
        )}
      </header>

      <main className="flex-1 flex items-start justify-center px-6 py-12">
        <div className="w-full max-w-md">{children}</div>
      </main>

      <footer className="mx-auto w-full max-w-6xl px-6 py-8 text-center text-xs text-ink/50 dark:text-paper/50">
        {t.auth.shell.footer}
      </footer>
    </div>
  );
}
